<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i style="color:#FFD700" class="fas fa-shapes mr-2" aria-hidden="true"></i>RIEPILOGO ORDINI TUTTE LE CATEGORIE</h4>
  </div> 

 <div class="card-body"> 
  
 <div class="row">
 <div  v-if="items.length==0" class="col-md-4"> 

<div class="card border-info" >
  <div class="card-header bg-info">
    <i style="color:yellow" class="fas fa-stream mr-2" aria-hidden="true"></i>
    <strong>PARAMETRI DI RICERCA</strong></div>
  <div class="card-body text-dark">

  <form name="filter" v-on:submit.prevent="submit()">
    
     <collection-select v-bind:props="collection" @update="setCollectionId"></collection-select>     
    <department-select v-bind:props="department" @update="setDepartmentId"></department-select>

    <label ><strong>Tipo raggruppamento</strong></label>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" v-model="option" checked>
      <label class="form-check-label" for="exampleRadios1">
        ANALITICO
      </label>
    </div>
    <div class="form-check">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" v-model="option">
      <label class="form-check-label" for="exampleRadios2">
        SINTETICO
      </label>
    </div>

    
   <div class="card-footer bg-transparent border-info"> 
   <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
   <button type="submit" :disabled="spinner"  class="btn btn-primary float-right">
    <i class="far fa-play-circle  mr-2"></i>
    ESEGUI
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-3 text-warning" role="status" aria-hidden="true"></span>
     </button>           


  </div>
  </form>
 
  </div>
</div>

 </div>


<div v-else class="col">

  <h4 class="ml-3">

  <strong> {{ collection.name }} {{ department.name }} </strong>
  </h4>

  <button v-if="items.length>0"  @click="items=[],row_total=[]" type="button"  class="btn btn-secondary mb-1 ml-1 mr-3">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button> 

  <button :disabled="items.length==0 || spinner_pdf == true" @click="exportToPDF()" type="button"   class="btn btn-primary mb-1  ">
    <i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
      <span v-if="spinner_pdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>  
 
  
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

  <table id='my-table' class="table table table-sm table-hover  mb-0">
    <thead >
      <tr class="table-primary">

      
        <th scope="col">CATEGORIA</th>

        <th v-if="option=='option1'" scope="col">BRAND</th>

        
        <th v-if="option=='option1'" scope="col">REPARTO</th>                
        <th v-if="option=='option2' && department.Id==0" scope="col">REPARTO</th>                
        
        <th class="text-right" scope="col">ORDINATO</th>        
        <th class="text-right" scope="col">CONSEGNATO</th>
                        
        <th class="text-right text-nowrap" scope="col">ORDINATO €</th>
        <th class="text-right text-nowrap" scope="col">CONSEGNATO €</th>
                
      </tr>
    </thead>
    <tbody>

      <tr :style="{backgroundColor:setBG(item), color: setColor(item),fontSize: setFontSize(item) ,fontWeight:item.brand == null ? 'bold':'normal' }"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">

        
        <td >{{item.category}}</td>   
        <td v-if="option=='option1'" >{{item.brand}}</td>   
        <td v-if="option=='option1'">{{item.department}}</td>                        
        <td v-if="option=='option2' && department.Id==0">{{item.department}}</td>                        
        

        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
               
      </tr> 
    </tbody>
    <tfoot>
        <tr  data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in row_total" :key="index"> 
        
        <td> </td>
        <td v-if="option=='option1'"> </td>
        <td v-if="option=='option1'"> </td>
        <td v-if="option=='option2' && department.Id==0"> </td>
        
        
        
        <td class="text-right">{{fmt2(item.total1_qty)}} </td>        
        <td class="text-right">{{fmt2(item.total2_qty)}}</td>        
        <td class="text-right">{{fmt1(item.total1_val)}}</td>
        <td class="text-right">{{fmt1(item.total2_val)}}</td>
        
        
        </tr>   
    </tfoot>    
  </table>

</div>



</div>  

</div>

</div>

</div>

</div>

</template>
<script>
//import axios             from "axios";
import api               from '@/api'
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';

import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import collectionSelect  from '@/components/common/CollectionSelect_1.vue'


import jsPDF             from 'jspdf';
import fmt               from '@/components/mixins/fmt.js'


export default {
  components: {alertBox,departmentSelect, collectionSelect},
  mixins:[fmt],
  data() {
    return {
      option          : 'option1',
      pdf_title       : 
      {
        
        /*supplier      : 'Tutti i fornitori',*/
        department    : 'Tutti i reparti'
        
      },
 
      
      collection  : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true,
        typeId        : 1,
        name          : ''

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false,
        name          : ''
       
       
      },

      
      
      data1           : null,
      data2           : new Date().toISOString().slice(0,10),
      
      
      
      spinner         : false,
      spinner_pdf     : false,
      

      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
      
      items           : [],
      row_total       : [],
      grouping        : [],
      group_by        : 0
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {},
  created: function() {

    //this.getGrouping()
  },
  methods: {
   
   
   setCollectionId(Id,e)   
   { 
      this.collection.Id = Id
      this.collection.name = e.target.options[e.target.options.selectedIndex].text
      
   }, 
   setColor(item)
   {
       let color = 'black'
      

       if(item.brand == null )
       {
           color = 'blue'
       }

       
       if(item.brand == null && item.department == null)
       {
           color =  'green'
       }

       return color

   },
   setFontSize(item)
   {
    let fontSize = '14px'
    if(item.brand == null )
       {
           fontSize = '18px'
       }
       if(item.brand == null && item.department == null)
       {
           fontSize = '22px'
       }
       
       return fontSize
   },
   setBG(item)
   {
    let bg = 'white'
    if(item.brand == null )
       {
           //bg = '#B6B6B4'
       }
       return bg
    
   },
   async  exportToPDF()
    {
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }

      const addFooters = doc => {
          const pageCount = doc.internal.getNumberOfPages()
          doc.setFont('helvetica', 'italic')
          doc.setFontSize(8)
          for (var i = 1; i <= pageCount; i++) 
          {
            doc.setPage(i)

            doc.text('Pag. ' + String(i) + ' di ' + String(pageCount), 50,200, {
            align: 'center'})
          }
      }
       

      this.spinner_pdf = true
      await wait(0) 
      const doc = new jsPDF(
      {
         orientation: "landscape",
      })
      doc.setFontSize(8)
      var d = new Date();
      var n = d.toLocaleDateString();
      var t = d.toLocaleTimeString();
      doc.setFontSize(12)
      doc.text("RIEPILOGO ORDINI TUTTE LE CATEGORIE " + ' - ' + this.collection.name + '- ' +  this.department.name +  " del " + n + ' ' + t , 15, 10);
      doc.setFontSize(10)
     
      doc.autoTable(
      
    
       { html       : '#my-table',
       margin       : {top:20},
       showFoot     : 'lastPage',
       theme        : 'grid',

        headStyles: {
          fillColor: [41, 128, 185], // blu
          textColor: 255,            // bianco
          fontStyle: 'bold',
          
          /*
          0: { halign: 'left' },
          1: { halign: 'left' },
          2: { halign: 'left' },
          3: { halign: 'left' },
          */
          4: { halign: 'right' },
          5: { halign: 'right' },
          6: { halign: 'right' },
          7: { halign: 'right' },
        },
 


       footStyles   : {halign:'right',fontStyle:'bold',fillColor:'white',textColor:'black',fontSize:14,cellWidth: 'wrap',},
       
       
       columnStyles : { 2: { halign: 'right' }, 3: { halign: 'right' }, 4: { halign: 'right' }, 5: { halign: 'right' },6: { halign: 'right' } },
       
            

          didParseCell: function(data) {

          


           
            if (data.row.cells[0].text != '' && data.row.cells[1].text == '') 
            {
                            
              data.cell.styles.fontStyle = 'bold';
              data.cell.styles.fontSize = 12              
              
            }


                    
          }, 
        
        styles : {
          font       : 'helvetica',
          //rowHeight  : 5,  
          fontSize   : 8,
          }
        })
      
     
    addFooters(doc)
         
    var fileName = 'Report'
    window.open(doc.output('bloburl', { filename: fileName }), '_blank');
    this.spinner_pdf = false
    
      
     
    },

    
      
    
   

    setDepartmentId(departmentId,e)
    {

      this.department.Id    = departmentId      
      this.department.name = e.target.options[e.target.options.selectedIndex].text
      
    },

    submit() 
    {
      
      this.getData()
    },  
    
    
       
    
    async getData() {
      
      this.row_total = []
      this.items     = []
      this.msg.title = ''
            
      const sp = {'sp' : this.option == 'option1' ? 'spOrdersAllCategories' : 'spOrdersAllCategoriesTotals' }           
     
      const data  = {
        'collectionId' : this.collection.Id,
        'companyId'    : this.company.Id,
        'departmentId' : this.department.Id 
        
      }
      const  json  = Object.assign(data, sp)

      this.spinner = true
      
      await api.post(json).then(res => {
         
          if(res.status==200)
            {
              
              this.items = res.data.recordsets[0].filter(item=>item.category != null )
              this.row_total = res.data.recordsets[0].filter(item=>item.category == null && item.brand == null && item.department == null)
        
             
            if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type  = 1
              
            }
          
          else
          {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = res
            this.msg.type  = 1
                
                        

          }
      }).catch(err=>{
        
            this.msg.title = 'ATTENZIONE '
            this.msg.body = err.message
            this.msg.type  = 1
              

      }).finally(() => {
          this.spinner = false
        });
      
 

    }
  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position   : relative;
height     : 700px;
overflow   : auto;
}
.pointer:hover
{

  /*background-color: blue;*/
 /* color: white;*/
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    color       : rgb(16, 16, 15) !important;
    background  : #a9cbe2 !important;
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

.table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    font-weight  : bold;
    background-color: white;
    color        : black;
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 30px;

     
    border-color  : white !important;
    border-top    : 2px solid #3f28a7 !important; 
    border-bottom : 2px solid #4128a7 !important;

 }


.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
 
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}
.card-header
{
  height: 45px;
}

.table {
  border-collapse: separate;
}
</style>